export default __webpack_public_path__ + "static/media/1795.7e6dfcad.png";